import { ApiProperty } from "@nestjs/swagger";

export class ZoneByIdDto{
    @ApiProperty()
    zoneId:number;
}